
import api from '@/api/api.coffee'
import translate from '@/mixins/translate.coffee'
export default
  name: 'translate'
  mixins: [ translate ]
  props:
    source:
      type: String
      required: true
  data: ->
    translated: @source
  render: (h) ->
    @_v(@translated)
  watch:
    source:
      immediate: true
      handler: -> @refresh()
    destinationLanguage: -> @refresh()
  methods:
    refresh: ->
      console.log('refresh', @source) if  @dev
      @translated = @source # fall back to source while loading
      try
        @translated = await @translate(@source)
      catch
        @translated = @source
  computed:    
    destinationLanguage: -> @$store.getters.destinationLanguage
    dev: -> @$store.getters.dev
